import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';

interface Prop {
  callbackValue: (name: string) => void;
  /**
   * True when the provider already has a secret stored. The current value is never
   * sent to the browser, so the field starts empty and an empty field on save means
   * "keep the existing secret".
   */
  hasExistingSecret?: boolean;
}

export default function ClientSecret(prop: Prop) {
  const { callbackValue: sendbackClientSecret, hasExistingSecret = false } = prop;
  const [clientSecret, setClientSecret] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const handleClientSecretBlur = (secret: string) => {
    sendbackClientSecret(secret);
  };

  return (
    <TextField
      label="Klienthemmelighet"
      fullWidth
      value={clientSecret}
      // Masked so the value cannot be read off the screen while typing it in.
      type={isVisible ? 'text' : 'password'}
      autoComplete="new-password"
      onChange={(event) => setClientSecret(event.target.value)}
      onBlur={(event) => handleClientSecretBlur(event.target.value)}
      margin="normal"
      required={!hasExistingSecret}
      placeholder={hasExistingSecret ? 'Uendret' : ''}
      helperText={
        hasExistingSecret
          ? 'Den lagrede hemmeligheten vises ikke. La feltet stå tomt for å beholde den, eller lim inn en ny for å bytte.'
          : 'Lagres kryptert og kan ikke hentes ut igjen senere.'
      }
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={isVisible ? 'Skjul klienthemmelighet' : 'Vis klienthemmelighet'}
                onClick={() => setIsVisible(!isVisible)}
                edge="end"
                size="large">
                {isVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
